//const Backofficebff         : string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OrderQuery: any = {
    GetOrderStatusList: Backofficebff + '/v1/order/orderstatuslist',
    GetSellerNameListAll: Backofficebff + '/v1/order/getsellernameall',
    GetOrderActionRules: Backofficebff + '/v1/orderapi/getorderactionrules',
    GetShippingListPackageDetail: Backofficebff + '/v1/order/get-shipping-list-package-detail',
    GetUserSaleOrderStatusHistory: Backofficebff + '/v1/order/get-sale-order-status-history',
    GetShippingListCancelReason: Backofficebff + '/v1/orderapi/getshippinglistcancelreason',
    GetOrderIdFromDigitalCardNo: Backofficebff + '/v1/order/get-orderid-from-digital-card-no',
    GetOrderShipmentStatus: Backofficebff + '/v1/order/get-shipping-list-status-by-role',
    GetOrderCancelReason: Backofficebff + '/v1/order/get-order-cancel-reason',
    GetShippingListByRole: Backofficebff + '/v1/order/get-shipping-list-by-role',
    GetOrderShipmentStatusForStatusChange: Backofficebff + '/v1/order/get-shipping-status-for-status-change',
    VerifyOtp: Backofficebff + '/v1/order/check-order-otp-verification',
    ResendOtp: Backofficebff + '/v1/order/resend-otp',
    GetShippingStatusesFromRuleServiceByShipmentId:
        Backofficebff + '/v1/order/get-shipping-statuses-from-rule-service-by-shipment-id',
    GetShipmentStatusList: Backofficebff + '/v1/order/get-shipment-status-list',
    CheckOtpAvailability: Backofficebff + '/v1/order/check-otp-availability',
    CheckCancelShipmentCallCenterRole: Backofficebff + '/v1/order/check-cancel-shipment-call-center-role',
    GetReshippingActionButtonRule: Backofficebff + '/v1/order/reshipping-action-button-rule',
    SearchOrdersByIdentifiers: Backofficebff + '/v1/order/search-orders-by-identifiers',
    //SearchOrdersByIdentifiers: Backofficebff + '/v1/order/search-orders-by-identifiers-mock',
};
